import styled from "styled-components";

const SubsectionText = styled.p`
    font-size: 16px;
    font-family: Roboto Condensed, serif;
    color: ${({color}) => color ?? 'black'};
    margin: 0;
    max-width: 800px;
    text-align: center;
    font-weight: 300;
    margin-top: 20px;
    line-height: 1.5;
    text-align: center;
`;

export default SubsectionText;
